import { flare } from "@flareapp/flare-client";
import { flareVue } from "@flareapp/flare-vue";
import VueI18n from 'vue-i18n';
import translationStrings from './translation.js';


if (process.env.NODE_ENV === 'production') {
    flare.light('REWJuDiNSh0a5FJOea6Q7wm9xUR76ZMc');
}

require('vue-slider-component/theme/default.css');

window.Vue = require('vue').default;

Vue.use(VueI18n);

// const response = await fetch('/preferences/language');
// const lang = await response.json();

const i18n = new VueI18n({
  locale: window.locale,
  messages: translationStrings,
});

Vue.config.productionTip = false;
Vue.config.silent = true;

Vue.use(flareVue);

require('vue-scrollactive');
// https://github.com/eddiemf/vue-scrollactive

require('v-tooltip');
// https://www.npmjs.com/package/v-tooltip

require('vue-select');
// https://vue-select.org/

require('v-click-outside');
// https://www.npmjs.com/package/v-click-outside

require('vue-chartjs');
// https://vue-chartjs.org/guide/

require('vuedraggable');
// https://github.com/SortableJS/Vue.Draggable

require('vue2-editor');
// https://github.com/davidroyer/vue2-editor#readme
// https://github.com/davidroyer/vue2-editor/issues/106

require('chart.js');

require('vue-html-to-paper');
// https://github.com/mycurelabs/vue-html-to-paper#readme

require('v-mask');
// https://github.com/probil/v-mask

require('vue-slider-component');
// https://nightcatsama.github.io/vue-slider-component/

require('vue-tree-navigation');
// https://misrob.github.io/vue-tree-navigation/

require('v-video-embed');
// https://github.com/nasa8x/v-video-embed

require('vue-typical');
// https://github.com/Turkyden/vue-typical

import { FocusTrap } from 'focus-trap-vue';
Vue.component('FocusTrap', FocusTrap);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component(
  'language-switcher',
  require('./components/language-switcher.vue').default
)
Vue.component(
  'example-component',
  require('./components/ExampleComponent.vue').default
)
Vue.component(
  'click-to-edit',
  require('./components/ClickToEdit.vue').default
)
Vue.component(
  'click-add-person',
  require('./components/ClickAddPerson.vue').default
)
Vue.component(
  'autocomplete',
  require('@trevoreyre/autocomplete-vue').default
)
Vue.component(
  'vt-accordion',
  require('./components/visual-type-accordion.vue').default
)
Vue.component(
  'score-accordion',
  require('./components/score-accordion.vue').default
)
Vue.component(
  'accordion',
  require('./components/accordion.vue').default
)
Vue.component(
  'button-additem',
  require('./components/button-additem.vue').default
)
Vue.component(
  'groupaddmember',
  require('./components/group-addmember.vue').default
)
Vue.component(
  'Annotation',
  require('./components/annotation/annotation').default
)
Vue.component(
  'AnnotationToggle',
  require('./components/annotation/annotation-toggle').default
)
Vue.component(
  'AnnotationAggregator',
  require('./components/annotation/annotation-aggregator').default
)
Vue.component(
  'ReportSectionIndex',
  require('./components/report-sections/report-section-index').default
)
Vue.component(
  'ReportSidebarNav',
  require('./components/report-sidebar-nav').default
)
Vue.component(
  'ProfileNav',
  require('./components/profile-nav').default
)
Vue.component(
  'VisualTypeBuilder',
  require('./components/visual-type-builder').default
)

/** Vue Components Created by Others **/

Vue.component(
  'vue-scrollactive',
  require('vue-scrollactive').default
)
Vue.component(
  'v-tooltip',
  require('v-tooltip').default
)
Vue.component(
  'v-select',
  require('vue-select').default
)
Vue.component(
  'v-clipboard',
  require('vue-clipboard2').default
)
Vue.component(
  'v-click-outside',
  require('v-click-outside').default
)
Vue.component(
  'draggable',
  require('vuedraggable').default
)
Vue.component(
  'vue2-editor',
  require('vue2-editor').default
)
Vue.component(
  'VueHtmlToPaper',
  require('vue-html-to-paper').default
)
Vue.component(
  'VueSlider',
  require('vue-slider-component').default
)
Vue.component(
  'VueTreeNavigation',
  require('vue-tree-navigation').default
)
Vue.component(
  'v-video-embed',
  require('v-video-embed').default
)
Vue.component(
  'vue-typical',
  require('vue-typical').default
)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
  el: '#app',
  i18n,
})
